import { css } from 'emotion'

export const marginBottomMediumStyles = css`
  margin-bottom: 16px;
`
